import { gql } from "@apollo/client";

import { propertyFragment } from "src/graphql/anti-fraud/fragments/PropertyFragment";

export const propertyValueFragment = gql`
  fragment PropertyValueFragment on PropertyValue {
    property {
      ...PropertyFragment
    }
    value
  }

  ${propertyFragment}
`;
